import { useLocation, Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export default function Legal() {
  const { pathname } = useLocation();
  const isCgu = pathname === "/conditions-generales";
  return (
    <div className="bg-[#FAF8F5] min-h-screen">
      <Navbar />
      <main className="max-w-2xl mx-auto px-4 sm:px-6 pt-32 pb-24">
        <h1 className="font-heading text-4xl font-extrabold text-stone-900">
          {isCgu ? "Conditions générales" : "Politique de confidentialité"}
        </h1>
        <div className="mt-8 space-y-4 text-sm text-stone-600 leading-relaxed">
          <p className="font-semibold text-[#E05638]">
            Document provisoire — à faire valider juridiquement avant mise en production.
          </p>
          {isCgu ? (
            <>
              <p>1. FodindinCa est une plateforme de rencontres réservée aux personnes majeures (18 ans et plus).</p>
              <p>2. Chaque membre s'engage à fournir des informations exactes et à respecter les autres membres.</p>
              <p>3. Les abonnements et suppléments d'accès sont valables pour la durée choisie et ne sont pas remboursables.</p>
              <p>4. Tout comportement abusif (harcèlement, arnaque, faux profil) peut entraîner la suspension du compte.</p>
            </>
          ) : (
            <>
              <p>1. Vos préférences de rencontre servent uniquement à personnaliser les profils proposés.</p>
              <p>2. Votre numéro de téléphone n'est utilisé que pour les alertes que vous avez activées.</p>
              <p>3. Vos données ne sont jamais revendues à des tiers.</p>
              <p>4. Vous pouvez demander la suppression de votre profil à tout moment.</p>
            </>
          )}
        </div>
        <Link to="/" className="mt-10 inline-block text-[#E05638] font-semibold text-sm">← Retour à l'accueil</Link>
      </main>
      <Footer />
    </div>
  );
}
